import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout from '../components/LegalLayout';

const DataDeletion: React.FC = () => (
  <LegalLayout title="Eliminazione dei Dati dell'Utente" lastUpdated="17 giugno 2026">
    <p>
      In conformità all'art. 17 del Regolamento (UE) 2016/679 («diritto alla cancellazione») e alle
      policy di Meta, garantiamo a ogni utente la possibilità di richiedere l'eliminazione dei propri
      dati personali raccolti tramite l'assistente ChatLy su WhatsApp. Il Titolare del trattamento è{' '}
      <strong>Alessio Di Como – Delta Code</strong>, Via di Sant'Alessio 39, 51100 Pistoia (PT) —
      P.IVA 02138520479.
    </p>

    <h2>Cosa comporta l'eliminazione dei dati</h2>
    <p>
      Una volta accolta la richiesta, rimuoveremo in modo permanente i dati personali associati al tuo
      numero di telefono in relazione all'utilizzo del bot WhatsApp, tra cui:
    </p>
    <ul>
      <li>il numero di telefono salvato nei nostri sistemi;</li>
      <li>la cronologia delle conversazioni e i messaggi scambiati con il bot;</li>
      <li>eventuali altre informazioni associate alla tua interazione.</li>
    </ul>
    <p>
      Resta salva la conservazione dei dati eventualmente necessaria per adempiere a obblighi di legge
      o per l'accertamento, l'esercizio o la difesa di un diritto in sede giudiziaria.
    </p>

    <h2>Tempi di elaborazione</h2>
    <p>
      Una volta ricevuta e verificata la richiesta, provvederemo alla cancellazione dai sistemi attivi
      entro un massimo di <strong>30 giorni</strong>. Tempi superiori possono rendersi necessari in
      ragione della complessità della richiesta o della rotazione dei backup, dei quali la rimozione
      avviene comunque entro i normali cicli di sovrascrittura.
    </p>

    <h2>Come richiedere l'eliminazione</h2>

    <div className="mt-4 rounded-xl border border-border bg-muted/40 p-6">
      <h3 className="mb-3 text-lg font-semibold text-text-primary">Opzione 1 — Richiesta via email</h3>
      <p className="mb-4 text-text-secondary">
        Invia una richiesta di cancellazione totale o parziale dei tuoi dati:
      </p>
      <ul className="list-disc space-y-2 pl-6 text-text-secondary">
        <li>
          indirizzo: <a href="mailto:info@chatly.it" className="font-medium text-primary underline">info@chatly.it</a>;
        </li>
        <li>oggetto: «Richiesta Eliminazione Dati»;</li>
        <li>nel messaggio, indica il numero di telefono utilizzato con il bot per l'identificazione.</li>
      </ul>
    </div>

    <div className="mt-6 rounded-xl border border-primary/20 bg-primary/10 p-6">
      <h3 className="mb-3 text-lg font-semibold text-text-primary">Opzione 2 — Tramite WhatsApp</h3>
      <p className="text-text-secondary">
        Invia il comando <strong>/elimina-dati</strong> al bot su WhatsApp e segui le istruzioni per
        confermare l'operazione. Questa modalità consente una rimozione automatizzata più rapida.
      </p>
    </div>

    <h2>Altri diritti</h2>
    <p>
      Oltre alla cancellazione, puoi esercitare gli altri diritti previsti dal GDPR (accesso,
      rettifica, limitazione, portabilità, opposizione) e proporre reclamo al Garante. Per i dettagli
      consulta la <Link to="/privacy">Informativa sulla Privacy</Link>.
    </p>
  </LegalLayout>
);

export default DataDeletion;
